import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import Pengaturan from "./components/pengaturan";
function Login() {
  const [uname, setUname] = useState("");
  const [password, setPassword] = useState("");
  const [validation, setValidation] = useState([]);
  const history = useHistory();
  const [mikrotik, setMikrotik] = useState({});
  const [idRouter, setIdRouter] = useState("");
  const [showLoading, setShowLoading] = useState("");
  const ambilRouter = async () => {
    //axios.defaults.headers.common['Access-Control-Allow-Origin'] = `*`;
    await axios
      .get(Pengaturan["urlApi"] + "getallrouter", {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => {
        setMikrotik(response.data);
      });
  };

  useEffect(() => {
    ambilRouter();
    if (localStorage.getItem("token")) {
      history.push(Pengaturan["baseurl"] + "dashboard");
    }
  }, []);
  const loginHandler = async (e) => {
    setShowLoading(
      <div className="alert alert-warning">
        Proses Login, Silahkan Tunggu...
      </div>
    );
    setValidation("");
    e.preventDefault(); //agar ketika klik tombol login tidak langsung submit
    const formData = new FormData();
    formData.append("username", uname);
    formData.append("password", password);
    formData.append("id_router", idRouter);
    await axios
      .post(Pengaturan["urlApi"] + "login", formData)
      .then((response) => {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("rtr", idRouter);
        localStorage.setItem("router", response.data.router);
        setShowLoading("");
        history.push(Pengaturan["baseurl"] + "dashboard");
      })
      .catch((error) => {
        setShowLoading("");
        setValidation(error.response.data);
        console.log("error", error.response.data);
      });
  };
  const selectRouter = [];
  for (let i = 0; i < mikrotik.length; i++) {
    selectRouter.push(
      <option value={mikrotik[i].id} key={i}>
        {mikrotik[i].nama}
      </option>
    );
  }
  return (
    <div className="row justify-content-center">
      <div className="col-md-4">
        <div className="card border-0 rounded shadow-sm">
          <div className="card-body">
            <h4 className="fw-bold">Billing RCC</h4>
            <hr />
            {showLoading}
            {validation.message && (
              <div className="alert alert-danger">{validation.message}</div>
            )}
            <form onSubmit={loginHandler}>
              <div className="mb-3">
                <label className="form-label">Username</label>
                <input
                  type="text"
                  className="form-control"
                  value={uname}
                  onChange={(e) => setUname(e.target.value)}
                  placeholder="Username"
                  require
                />
              </div>
              {validation.username && (
                <div className="alert alert-danger">
                  {validation.username[0]}
                </div>
              )}
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  require
                />
              </div>
              {validation.password && (
                <div className="alert alert-danger">
                  {validation.password[0]}
                </div>
              )}
              <div className="mb-3">
                <label className="form-label">Router</label>
                <select
                  className="form-control"
                  onChange={(e) => setIdRouter(e.target.value)}
                  require
                >
                  <option value="" selected>
                    Pilih Router
                  </option>
                  {selectRouter}
                </select>
              </div>
              <div className="d-grid gap-2">
                <button type="submit" className="btn btn-primary">
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Login;
